module.exports = __webpack_public_path__ + "static/media/SK01@m.40be1920.jpg";